export default __webpack_public_path__ + "static/media/Landingimg.e9d8c9db.png";